
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupSubscription",
      function () {
        return require("private-next-pages/groupSubscription.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groupSubscription"])
      });
    }
  